var React = require('react');

function BaselineQueueMusic24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z","key":1})]);
}

BaselineQueueMusic24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselineQueueMusic24px;

BaselineQueueMusic24px.default = BaselineQueueMusic24px;
